import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import user from "../../../../../Assets/Images/doctordp1.jpeg";
import QR from "../../../../../Assets/Images/qrcode.png";
import { CloseOutlined } from "@ant-design/icons";
import { MdDownloadForOffline } from "react-icons/md";
import { FiDownload } from "react-icons/fi";
import { IoShareSocial } from "react-icons/io5";
import home from "../../../../../Assets/Images/medical6.jpg";
import { useParams } from "react-router-dom";
import { Base64 } from "js-base64";
import MedicalHistoryService from "../../../../../Services/MedicalHistoryService";
import CommonFunctions from "../../../../Shared/CommonFunctions";
import { QRCodeCanvas } from "qrcode.react";
import PatientService from "../../../../../Services/PatientService";
import { HSdecrypt } from "../../../../../utils/passwordEncrypt";

function EmergencyData() {
  const params = useParams();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [patientQrData, setPatientQrData] = useState();
  const [patientData, setPatientData] = useState();
  const [medicationData, setMedicationData] = useState([]);
  const [drugAlleryData, setDrugAlleryData] = useState([]);
  const [chronicData, setChronicData] = useState([]);

  const showModal = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleDownload = async () => {
    const pdf = new jsPDF();
    const frontSide = document.querySelector(".card-front");
    const backSide = document.querySelector(".card-back");

    if (frontSide) {
      const frontCanvas = await html2canvas(frontSide);
      const frontImage = frontCanvas.toDataURL("image/png");
      pdf.addImage(frontImage, "PNG", 10, 10, 180, 100);
    }

    pdf.addPage();

    if (backSide) {
      const backCanvas = await html2canvas(backSide);
      const backImage = backCanvas.toDataURL("image/png");
      pdf.addImage(backImage, "PNG", 10, 10, 180, 100);
    }

    pdf.save("EmergencyMedicalCard.pdf");
  };

  const [isFlipped, setIsFlipped] = useState(false);

  const handleCardClick = () => {
    setIsFlipped((prev) => !prev);
  };
  useEffect(() => {
    let decodedValues = Base64.decode(params?.id);
    let splitValues = decodedValues.split("|");
    let payload = {
      patientId: splitValues[0],
    };
    PatientService.PatientQrData(payload).then((res) => {
      setPatientData(res.data[0]);
    });
    PatientEmergencyData(splitValues[0]);
    Medication(splitValues[0]);
    PatientAllery(splitValues[0]);
    PatientchronicConditions(splitValues[0]);
  }, []);

  const PatientEmergencyData = (patientId) => {
    let payload = {
      status: 1,
      patientId: patientId,
    };
    MedicalHistoryService.PatientQrList(payload).then((result) => {
      if (result?.data[0]?.healthCardUrl) {
        let url =
          process.env.REACT_APP_BASEURL + "emergencyqr/" +
          result?.data[0]?.healthCardUrl;
        setPatientQrData(url);
      }
    });
  };

  const Medication = (patientId) => {
    const payload = {
      patientCode: patientId,
      status: 1,
    };
    MedicalHistoryService.PatientEmergencyMedication(payload).then((result) => {
      const decryptedData = HSdecrypt(result.data.data);
      setMedicationData(JSON.parse(decryptedData));
    });
  };

  const PatientAllery = (patientId) => {
    const payload = {
      patientCode: patientId,
      status: 1,
    };
    MedicalHistoryService.PatientEmergencyAllergy(payload).then((result) => {
      const decryptedData = HSdecrypt(result.data.data);
      const parsedAllergyData = JSON.parse(decryptedData);
      const filteredDrugAllergies = parsedAllergyData?.map((item) => ({
        drugAllergy: item["drugAllergy"],
      }));
      setDrugAlleryData(filteredDrugAllergies);
    });
  };

  const PatientchronicConditions = (patientId) => {
    let payload = {
      patientId: patientId,
      status: 1,
    };
    MedicalHistoryService.HSPatientchronicConditions(payload)
      .then((result) => {
        const decryptedData = HSdecrypt(result.data.data);
        setChronicData(JSON.parse(decryptedData));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const calculateAge = (dobString) => {
    const dobData = dobString;
    const dobYear = dobData?.split("/")[2];
    const currYear = new Date().getFullYear();
    if (dobYear) {
      const patientAge = currYear - Number(dobYear);
      return patientAge;
    }
  };

  return (
    <div className="h-[90%] w-[580px] m-5 border rounded-lg shadow-lg overflow-y-scroll scrollWidth">
      <div className="h-[10%] bg-blue-600 flex items-center justify-center rounded-t-lg py-2">
        <h1 className="font-bold text-lg text-white text-center">
          Emergency Medical Data
        </h1>
      </div>
      <div className="overflow-y-scroll scrollWidth bg-gray-50 p-4">
        <div className="p-1">
          <div className="flex justify-between">
            <div className="">
              <div className="">
                {/* <h3 className="font-medium">Patient:</h3> */}
                <div>
                  <h5 className="text-xs font-medium text-gray-500">
                    Name:{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      {patientData?.salutation +
                        " " +
                        patientData?.firstName +
                        " " +
                        patientData?.lastName}
                    </span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    Age:{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      {calculateAge(patientData?.ageDob)}
                    </span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    DOB:{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      {patientData?.dob}
                    </span>
                  </h5>
                  <h5 className="text-xs font-medium text-gray-500">
                    Address:{" "}
                    <span className="text-xs text-blue-900 font-bold">
                      {patientData?.address1}
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <div className="">
              {/* {patientQrData ?
                <>
                  <div className="w-full flex justify-center">
                    <button
                      className="border rounded-lg px-3 text-xs py-1 bg-blue-500 font-semibold text-white hover:bg-blue-900"
                      onClick={showModal}
                    >
                      View EMC
                    </button>
                  </div>
                  <div class="inline-block group mt-1 px-3">
                    <QRCodeCanvas value={patientQrData} size={100} />
                    <img
                      src={QR}
                      alt="Sample Image"
                      class="w-32 h-24 rounded-lg shadow-lg shadow-blue-500/30 cursor-pointer transition-all duration-300"
                    /> 
                     <div className="flex gap-3 justify-end items-center mt-1">
                      <FiDownload className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                      <IoShareSocial className="w-4 h-4 text-blue-900 font-bold text-base cursor-pointer" />
                    </div> 
                  </div>
                </>
                :
                <>
                  <div className="w-full flex justify-end">
                    <button
                      className="border rounded-lg px-3 text-xs py-1 bg-blue-500 font-semibold text-white hover:bg-blue-900"
                    >
                      Generate QR Card
                    </button>
                  </div>
                </>
              } */}
            </div>
          </div>
          <div className="h-7 bg-red-600 flex items-center justify-center mt-1">
            <p className="text-sm font-semibold text-white mt-3">
              Emergency Contact
            </p>
          </div>
          <div className="flex justify-between items-center mt-2">
            <h6 className="text-xs font-medium">
              Name:{" "}
              <span className="text-sm font-semibold">
                {patientData?.salutation +
                  " " +
                  patientData?.firstName +
                  " " +
                  patientData?.lastName}
              </span>
            </h6>
            <h6 className="text-xs font-medium">
              Mobile Number:{" "}
              <span className="text-sm font-semibold">
                {patientData?.mobile}
              </span>
            </h6>
          </div>
          <hr className="mt-1" />
          <div className="flex items-center justify-center text-center mt-1">
            <p className="text-sm font-semibold !mb-0">
              Access my personal Health Records At:
              <br />
              <a
                href={`${process.env.REACT_APP_WEBSITEURL?.replace(/\/$/, "")}/PHR-ACCESS/${patientData?.patientId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500"
              >
                {`${process.env.REACT_APP_WEBSITEURL.replace(
                  /^https?:\/\//,
                  ""
                )}PHR-ACCESS`}
              </a>
              <p className="text-sm font-semibold !mb-0">
                MEMBER ID:{" "}
                <span className="text-sm font-bold text-blue-950">
                  {patientData?.patientId}
                </span>
              </p>
            </p>
          </div>
          <hr className="mt-2" />
          <div className="mt-2">
            <div className="flex gap-2 items-center">
              <p className="font-medium text-xs">Blood Group:</p>
              <p className="font-medium text-blue-900 mt-1">
                {patientData?.bloodGroup}
              </p>
            </div>
            {/* <div className="flex gap-2 items-center">
              <p className="font-medium text-xs mt-1">Chronic Conditions:</p>
              <div>
                <h6 className="font-semibold text-blue-900">Renal Disease</h6>
                <h6 className="font-semibold text-blue-900"></h6>
              </div>
            </div> */}

            {/* <div className="flex gap-2 items-center">
              <p className="font-medium text-xs">Drug Allergy:</p>
              {drugAlleryData.map((row, index) => (
                <p className="font-bold text-blue-900 mt-1">
                  {row?.drugAllergy}
                </p>
              ))}
            </div> */}
            <div
              className={`${drugAlleryData.length === 1 ? "flex gap-2" : ""}`}
            >
              <p className="font-medium text-xs mt-1">Drug Allergy:</p>
              <div
                className={`border rounded-lg p-2 grid  
                  ${drugAlleryData.length === 1 ? "block" : ""} 
                  ${
                    drugAlleryData.length > 15
                      ? "md:grid-cols-3"
                      : "md:grid-cols-2"
                  } 
                  grid-cols-2`}
              >
                {drugAlleryData?.map((item, idx) => (
                  <p key={idx} className="text-sm font-medium text-blue-900">
                    {item.drugAllergy}
                  </p>
                ))}
              </div>
            </div>

            <div className={`${chronicData.length === 1 ? "flex gap-2" : ""}`}>
              <p className="font-medium text-xs mt-2">Chronic Conditions:</p>
              <div
                className={`border rounded-lg p-2 grid  
                  ${chronicData.length === 1 ? "block" : ""} 
                  ${
                    chronicData.length > 15
                      ? "md:grid-cols-3"
                      : "md:grid-cols-2"
                  } 
                  grid-cols-2`}
              >
                {chronicData?.map((item, idx) => (
                  <>
                    <div key={idx} className="">
                      <p className="text-sm font-medium text-blue-900 truncate">
                        {item.chronicDescription}
                      </p>
                    </div>
                  </>
                ))}
              </div>
            </div>
            <div className="flex gap-2 items-center mt-2">
              <p className="font-medium text-xs">Insurance:</p>
              <p className="font-medium text-blue-900 mt-1">
                {patientData?.insurance}
              </p>
            </div>
            <div className="">
              <p className="font-medium text-xs">Current Medications:</p>
              <div className="overflow-x-auto scrollwidth">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {medicationData.map((row, index) => (
                    <div
                      key={index}
                      className="bg-white p-2 rounded-lg shadow-md border border-gray-300"
                    >
                      <div className="">
                        {/* Drug Details Section */}
                        <div className="flex justify-between items-center mb-2">
                          <p className="text-sm font-bold text-blue-950 mx-2">
                            {row.drugName}
                          </p>
                          <p className="text-sm font-medium text-blue-950 mx-2">
                            {row.dosage}
                          </p>
                          <p
                            className="text-sm font-medium text-blue-950 mx-2"
                            style={{ minInlineSize: "fit-content" }}
                          >
                            {row.frequency}
                          </p>
                        </div>

                        {/* Date Section */}
                        <div className="flex justify-between">
                          <div className="flex items-center gap-1">
                            <h6 className="text-xs text-blue-950 font-medium">
                              From:
                            </h6>
                            <div className="border rounded-md text-[10px] px-2 py-1 mb-1">
                              {row?.startCreatedTime?.slice(0, 10)}
                            </div>
                          </div>
                          <div className="flex items-center gap-1">
                            <h6 className="text-xs text-blue-950 font-medium">
                              To:
                            </h6>
                            <div className="border rounded-md text-[10px] px-2 py-1 mb-1">
                              {row?.endCreatedTime?.slice(0, 10)}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-[5%] bg-blue-600 flex items-center justify-end rounded-b-lg p-2"></div>
      <Modal
        title={
          <div className="flex justify-end space-x-4">
            <MdDownloadForOffline
              className="text-blue-600 cursor-pointer font-bold w-6 h-6"
              onClick={handleDownload}
            />
            <CloseOutlined
              className="text-white cursor-pointer"
              onClick={handleCancel}
            />
          </div>
        }
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <div
          className="relative w-full h-[250px] perspective cursor-pointer"
          onClick={handleCardClick}
        >
          <div
            className={`relative w-full h-full transform-style-preserve-3d transition-transform duration-700 ${
              isFlipped ? "rotate-y-180" : ""
            }`}
          >
            <div className="absolute w-full backface-hidden border-2 border-slate-200 rounded-lg bg-white">
              <div className="h-10 bg-blue-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="w-full p-2 flex justify-evenly">
                <div className="flex gap-5 w-[75%]">
                  <div className="w-24 h-24 bg-white border rounded-xl flex items-center justify-center">
                    <img src={user} alt="" className="w-20 h-20 rounded-xl" />
                  </div>
                  <div>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Name:{" "}
                      <span className="font-bold text-blue-950">Balaji</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Age: <span className="font-bold text-blue-950">28</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      BloodGroup:{" "}
                      <span className="font-bold text-blue-950">AB+</span>
                    </h4>
                    <h4 className="text-sm font-medium text-gray-900 mt-2">
                      Mobile No:{" "}
                      <span className="font-bold text-blue-950">
                        8870558276
                      </span>
                    </h4>
                  </div>
                </div>
                <div className="w-[25%]">
                  <div className="w-24 h-24 rounded-lg flex items-center justify-center bg-white border">
                    <img src={QR} alt="" className="w-20 h-20 rounded-full" />
                  </div>
                </div>
              </div>
              <div className="h-7 bg-red-600 flex items-center justify-center">
                <p className="text-sm font-semibold text-white mt-3">
                  Emergency Contact
                </p>
              </div>
              <div className="flex justify-evenly items-center mt-2">
                <h6 className="text-xs font-medium">
                  Name: <span className="text-sm font-semibold">HariHaran</span>
                </h6>
                <h6 className="text-xs font-medium">
                  Mobile Number:{" "}
                  <span className="text-sm font-semibold">9976685889</span>
                </h6>
              </div>
            </div>
            <div className="absolute w-full h-60 backface-hidden rotate-y-180 border-2 border-slate-200 rounded-md">
              <div className="h-10 bg-blue-800 rounded-md flex justify-center items-center">
                <p className="font-semibold text-center text-base mt-4 text-white">
                  Emergency Medical Card
                </p>
              </div>
              <div className="p-5">
                <div className="flex items-center justify-center text-center mt-5">
                  <p className="text-sm font-semibold">
                    Access my personal Health Records At:
                    <br />
                    <span className="text-blue-500">
                      {`${process.env.REACT_APP_WEBSITEURL?.replace(
                        /^https?:\/\//,
                        ""
                      )}PHR-ACCESS`}
                    </span>
                  </p>
                </div>
                <div className="flex justify-center items-center gap-10">
                  <div>
                    <p className="text-sm font-semibold">
                      MEMBER ID :{" "}
                      <span className="text-sm font-bold text-blue-950">
                        1234567{" "}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
      </Modal>
    </div>
  );
}

export default function App() {
  return (
    <div
      className="flex items-center justify-end h-screen bg-gray-100"
      style={{
        // backgroundImage: `url(${home})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <EmergencyData />
    </div>
  );
}
